export const hexSize = 225;
export const defaultGridSize = hexSize * 10;
